var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3, _path29, _g4, _g5, _path30, _path31, _path32, _path33, _g6, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g7, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g8, _path59, _g9, _g10, _path60, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbandonBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 153,
    viewBox: "0 0 175 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.001 30.6476L153.402 7.93079L157.792 12.715L117.391 35.4318L113.001 30.6476Z",
    fill: "#9C8E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.888 32.7052L155.289 9.9884L157.792 12.7163L117.391 35.4331L114.888 32.7052Z",
    fill: "#281D28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M156.881 11.7225L157.826 12.7522L117.425 35.469L116.48 34.4393L156.881 11.7225Z",
    fill: "#281D28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M151.473 16.2653C151.473 16.2653 150.3 15.4539 148.396 16.4545C146.492 17.4551 147.239 18.6975 147.239 18.6975L151.473 16.2653Z",
    fill: "#281D28"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.224 16.7542C148.224 16.7542 149.43 16.4889 149.729 16.5269C150.029 16.565 150.229 16.555 150.504 16.363C150.778 16.172 150.896 16.0334 150.896 16.0334C150.896 16.0334 149.674 15.7908 148.766 16.2299C147.859 16.6682 147.478 17.1228 147.478 17.1228L148.224 16.7542Z",
    fill: "#281D28"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M151.826 9.68567C151.433 10.2706 150.963 10.8004 150.476 11.3192C149.983 11.8336 149.462 12.328 148.917 12.8061C148.37 13.2824 147.799 13.7424 147.198 14.1798C146.593 14.6154 145.969 15.0382 145.268 15.405C145.66 14.8191 146.129 14.2885 146.616 13.7714C147.109 13.2562 147.629 12.7627 148.176 12.2863C148.724 11.81 149.296 11.3509 149.897 10.9127C150.503 10.4762 151.125 10.0542 151.826 9.68567Z",
    fill: "#281D28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.967 9.45569C151.967 9.45569 150.016 12.0681 148.212 13.3984C146.406 14.7277 145.068 15.4467 145.068 15.4467C145.068 15.4467 147.279 14.5348 148.828 13.3757C150.375 12.2166 151.967 9.45569 151.967 9.45569Z",
    fill: "#CFC2C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M150.428 11.0667C150.428 11.0667 148.011 12.9085 147.66 13.2001C147.309 13.4908 146.075 14.6616 146.075 14.6616C146.075 14.6616 149.078 13.0896 150.428 11.0667Z",
    fill: "#281D28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.486 24.1289C125.486 24.1289 149.414 10.2109 150.629 10.0108C151.844 9.81068 144.394 14.3139 131.331 21.7465C118.269 29.179 122.165 27.6858 121.157 27.1597C120.149 26.6354 125.486 24.1289 125.486 24.1289Z",
    fill: "#CFC2C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.119 5.64336C149.789 4.68531 149.869 4.36566 157.862 2.17519C165.856 -0.0143791 172.158 -0.316826 172.676 0.248224C173.359 0.992569 170.809 5.38981 165.597 10.6147C160.384 15.8396 159.971 15.7971 158.919 15.2456C157.865 14.6941 151.123 12.3515 151.123 12.3515C151.123 12.3515 150.449 6.60141 150.119 5.64336Z",
    fill: "#908188"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M172.675 0.248291C172.675 0.248291 173.861 1.54229 165.596 10.6148C160.678 16.0126 159.97 15.7971 158.918 15.2457C157.864 14.6942 151.122 12.3516 151.122 12.3516C151.122 12.3516 151.121 12.3452 151.121 12.3371L172.645 0.267307C172.662 0.267307 172.675 0.248291 172.675 0.248291Z",
    fill: "#281D28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.121 12.3379C151.086 12.0445 150.44 6.57599 150.119 5.6433C149.981 5.24396 149.918 4.956 150.465 4.59741L158.996 7.93157L151.121 12.3379Z",
    fill: "#908188"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.995 7.93066L160.295 15.3252C159.685 15.6159 159.357 15.4755 158.918 15.2464C157.864 14.695 151.123 12.3524 151.123 12.3524C151.123 12.3524 151.122 12.346 151.122 12.3379L158.995 7.93066Z",
    fill: "#281D28"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.885 6.7011C154.725 6.23656 154.765 6.08171 158.637 5.02043C162.509 3.95915 165.814 4.08683 165.814 4.08683C165.814 4.08683 164.91 6.57794 162.385 9.1098C159.859 11.6417 159.659 11.6208 159.149 11.3537C158.639 11.0866 155.372 9.95104 155.372 9.95104C155.372 9.95104 155.045 7.16473 154.885 6.7011Z",
    fill: "#281D28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.464 4.59755C150.464 4.59755 154.624 6.12246 154.883 6.00293C155.142 5.8834 157.696 4.89456 160.16 4.40286C162.623 3.91115 165.808 3.8532 165.808 3.8532L172.676 0.248291L165.971 4.25978C165.971 4.25978 165.623 5.66154 163.844 7.81398C162.065 9.96643 159.825 11.3935 159.821 11.3917C159.818 11.3899 163.569 7.9154 164.581 6.35155C165.592 4.78771 165.572 4.14388 165.572 4.14388C165.572 4.14388 162.269 4.08502 158.934 5.01409C155.599 5.94316 155.009 6.43215 155.009 6.43215C155.009 6.43215 155.656 10.1349 155.371 9.95284C155.087 9.77083 154.479 6.51274 154.479 6.51274L150.464 4.59755Z",
    fill: "#CFC2C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M150.992 4.43271L154.745 5.7421C154.745 5.7421 157.199 4.54499 160.282 4.07231C163.365 3.59962 165.7 3.66572 165.7 3.66572L171.736 0.45291C171.736 0.45291 163.388 0.087076 150.992 4.43271Z",
    fill: "#CFC2C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.405 14.9513C158.405 14.9513 158.845 13.2951 156.007 12.193C153.169 11.0919 151.974 12.5643 151.974 12.5643L158.405 14.9513Z",
    fill: "#281D28"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.236 12.5942C153.128 12.6965 152.938 12.7137 152.938 12.7137L152.183 12.3705C152.183 12.3705 152.885 11.5836 154.675 11.8317C156.466 12.0798 157.439 12.8613 157.771 13.2697C158.103 13.6799 155.343 12.4918 154.236 12.5942Z",
    fill: "#281D28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.83 10.6782C160.83 10.6782 161.87 11.1699 163.033 10.0199C164.197 8.86984 163.394 8.05396 163.394 8.05396L160.83 10.6782Z",
    fill: "#CFC2C4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.681 10.5159C160.681 10.5159 161.721 11.0076 162.885 9.85763C164.049 8.7076 163.246 7.89172 163.246 7.89172L160.681 10.5159Z",
    fill: "#281D28"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.325 3.03095C159.01 3.06626 159.68 3.03638 160.345 2.99201C161.01 2.94311 161.67 2.86976 162.324 2.7774C162.979 2.68323 163.628 2.56822 164.271 2.42877C164.916 2.28479 165.555 2.12633 166.178 1.90175C165.493 1.86553 164.823 1.89451 164.158 1.93888C163.492 1.98778 162.833 2.06022 162.179 2.1553C161.524 2.24948 160.875 2.36538 160.231 2.50484C159.589 2.64882 158.95 2.80728 158.325 3.03095Z",
    fill: "#281D28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.062 3.01008C158.062 3.01008 161.205 3.06169 163.15 2.64787C165.095 2.23223 166.301 1.81116 166.301 1.81116C166.301 1.81116 164.553 2.62432 162.869 2.97204C161.184 3.31886 158.062 3.01008 158.062 3.01008Z",
    fill: "#CFC2C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.146 2.85797C160.146 2.85797 162.805 2.32914 163.212 2.26213C163.618 2.19512 165.18 2.02307 165.18 2.02307C165.18 2.02307 162.512 2.98474 160.146 2.85797Z",
    fill: "#281D28"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.244 6.59227L166.109 6.44648L164.895 6.29797C164.895 6.29797 165.423 6.54609 165.903 6.69731C166.383 6.84763 168.484 7.49961 168.484 7.49961L169.244 6.59227Z",
    fill: "#281D28"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M165.975 6.7344L164.952 6.30518C164.952 6.30518 166.235 7.02235 166.329 7.04952C166.421 7.07578 168.228 7.53851 168.347 7.47331C168.467 7.40902 165.975 6.7344 165.975 6.7344Z",
    fill: "#CFC2C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170.174 5.4115C170.174 5.4115 166.96 5.98289 166.669 6.01096C166.378 6.03903 164.954 6.30616 164.954 6.30616L166.11 6.44742L169.245 6.59322L170.174 5.4115Z",
    fill: "#281D28"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M150.553 7.60022L153.528 6.53984C153.528 6.53984 158.051 6.51177 158.286 6.49638C158.52 6.48008 162.632 5.4677 162.957 5.33277C163.281 5.19785 163.983 6.17039 164.226 6.22925C164.468 6.2872 162.916 8.03125 162.916 8.03125C162.916 8.03125 159.832 7.47344 159.74 7.36025C159.649 7.24797 156.243 7.22895 156.243 7.22895L150.612 8.3998L150.553 7.60022Z",
    fill: "#281D28"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M152.444 8.30654C152.444 8.30654 154.611 7.87551 154.744 7.82842C154.88 7.78133 156.786 7.60113 156.786 7.60113L162.146 7.88818C162.146 7.88818 160.047 7.4164 159.739 7.36026C159.431 7.30412 156.391 7.19727 156.391 7.19727L150.611 8.39981L152.444 8.30654Z",
    fill: "#CFC2C4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M150.606 8.29113L154.461 6.99351L156.963 6.80878L162.993 6.5824L163.727 7.0741C163.415 7.46348 163.064 7.86644 162.953 7.9914C162.931 8.00227 162.909 8.01223 162.883 8.0249C162.544 7.96333 159.828 7.4671 159.743 7.36025C159.651 7.24796 156.246 7.22894 156.246 7.22894L150.614 8.39979L150.606 8.29113Z",
    fill: "#281D28"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.615 124.653L155.503 104.721L172.077 106.214L172.131 106.237C169.414 105.098 161.114 100.631 158.701 95.2164C158.065 93.7884 157.42 91.4757 159.161 87.8835C160.361 85.4096 161.713 82.8677 163.146 80.1756C167.713 71.5957 172.435 62.7233 173.815 53.1927C175.613 40.7733 171.185 29.9994 160.653 21.1705C148.747 11.1879 146.705 11.1616 146.488 11.0919L127.859 21.8894C127.859 21.8894 135.36 27.0555 145.664 35.6933C155.411 43.8657 152.224 52.6231 142.625 70.6576C141.175 73.3805 139.677 76.1958 138.328 78.9794C134.617 86.6356 134.437 94.6197 137.808 102.07C144.314 116.45 161.659 123.856 163.615 124.653Z",
    fill: "url(#paint0_linear_1122_2364)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1122_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 7,
    width: 26,
    height: 26
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.104 17.4659L141.948 32.6616C137.532 29.1554 133.696 26.4424 131.014 24.635L142.35 7.50513C145.455 9.54166 150.348 12.9138 156.104 17.4659Z",
    fill: "url(#paint1_linear_1122_2364)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1122_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.104 17.466L141.948 32.6617C137.532 29.1555 136.721 28.2527 134.039 26.4452L152.892 15.338C155.997 17.3737 150.348 12.9139 156.104 17.466Z",
    fill: "url(#paint2_linear_1122_2364)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M166.021 26.4452C172.648 34.1793 175.27 43.1477 173.816 53.1927C173.009 58.7608 171.061 64.1052 168.671 69.2966L146.241 63.6461C152.01 51.9241 153.658 44.7441 148.43 38.4353C153.957 34.6393 161.138 29.7241 166.021 26.4452Z",
    fill: "url(#paint3_linear_1122_2364)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1122_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 75,
    width: 26,
    height: 35
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.891 86.1954H135.901C136.372 83.775 137.181 81.3599 138.335 78.9775C138.915 77.7804 139.526 76.5778 140.146 75.3789L160.076 86.0569C159.766 86.6699 159.464 87.2785 159.17 87.8824C158.991 88.2519 158.843 88.6051 158.711 88.9483L158.703 88.951C157.559 91.9401 158.13 93.9359 158.702 95.2163C158.926 95.7189 159.202 96.2142 159.517 96.6987L142.826 109.892C140.858 107.564 139.114 104.958 137.807 102.07C135.486 96.9377 134.85 91.5526 135.891 86.1954Z",
    fill: "url(#paint4_linear_1122_2364)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1122_2364)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1122_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 59,
    width: 32,
    height: 24
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M142.558 70.6668C144.776 66.4996 146.651 62.8285 148.104 59.5442L171.826 61.2267C169.68 67.7836 166.342 74.0589 163.082 80.1848C162.681 80.9391 162.287 81.6789 161.9 82.4124L140.844 73.9095C141.415 72.8202 141.99 71.7353 142.558 70.6668Z",
    fill: "url(#paint5_linear_1122_2364)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1122_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M142.56 70.6667C144.778 66.4994 146.653 62.8284 148.106 59.5441L171.828 61.2265C169.682 67.7835 166.344 74.0588 163.084 80.1847C162.683 80.939 162.289 81.6788 161.902 82.4123L140.846 73.9094C141.417 72.82 141.992 71.7352 142.56 70.6667Z",
    fill: "url(#paint6_linear_1122_2364)"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M123.044 24.1285L128.617 28.2487L126.405 29.492L122.654 24.2933L123.044 24.1285Z",
    fill: "#8B899C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2042 30.6476L20.8027 7.93079L16.4127 12.715L56.8142 35.4318L61.2042 30.6476Z",
    fill: "#9C8E96"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.3175 32.7052L18.916 9.9884L16.4129 12.7163L56.8144 35.4331L59.3175 32.7052Z",
    fill: "#281D28"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.3237 11.7225L16.3789 12.7522L56.7804 35.469L57.7252 34.4393L17.3237 11.7225Z",
    fill: "#281D28"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M22.7324 16.2653C22.7324 16.2653 23.9054 15.4539 25.8095 16.4545C27.7136 17.4551 26.9663 18.6975 26.9663 18.6975L22.7324 16.2653Z",
    fill: "#281D28"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.9808 16.7542C25.9808 16.7542 24.7754 16.4889 24.4758 16.5269C24.1762 16.565 23.9761 16.555 23.7007 16.363C23.4266 16.172 23.3086 16.0334 23.3086 16.0334C23.3086 16.0334 24.5313 15.7908 25.4394 16.2299C26.3463 16.6682 26.7269 17.1228 26.7269 17.1228L25.9808 16.7542Z",
    fill: "#281D28"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.3789 9.68567C22.7722 10.2706 23.2419 10.8004 23.7289 11.3192C24.2217 11.8336 24.7434 12.328 25.2882 12.8061C25.8354 13.2824 26.4057 13.7424 27.0072 14.1798C27.6122 14.6154 28.2358 15.0382 28.9368 15.405C28.5446 14.8191 28.0761 14.2885 27.5891 13.7714C27.0963 13.2562 26.5758 12.7627 26.0286 12.2863C25.4814 11.81 24.9088 11.3509 24.3084 10.9127C23.7023 10.4762 23.0799 10.0542 22.3789 9.68567Z",
    fill: "#281D28"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2383 9.45569C22.2383 9.45569 24.1886 12.0681 25.9932 13.3984C27.799 14.7277 29.1374 15.4467 29.1374 15.4467C29.1374 15.4467 26.9256 14.5348 25.3767 13.3757C23.83 12.2166 22.2383 9.45569 22.2383 9.45569Z",
    fill: "#CFC2C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.7773 11.0667C23.7773 11.0667 26.1939 12.9085 26.5456 13.2001C26.8961 13.4908 28.1304 14.6616 28.1304 14.6616C28.1304 14.6616 25.1273 13.0896 23.7773 11.0667Z",
    fill: "#281D28"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.719 24.1289C48.719 24.1289 24.7907 10.2109 23.576 10.0108C22.3614 9.81068 29.8112 14.3139 42.8737 21.7465C55.9362 29.179 52.0401 27.6858 53.0477 27.1597C54.0564 26.6354 48.719 24.1289 48.719 24.1289Z",
    fill: "#CFC2C4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0862 5.64336C24.4159 4.68531 24.336 4.36566 16.3426 2.17519C8.34915 -0.0143791 2.04694 -0.316826 1.52869 0.248224C0.846185 0.992569 3.39576 5.38981 8.60827 10.6147C13.8208 15.8396 14.2338 15.7971 15.2864 15.2456C16.3403 14.6941 23.0821 12.3515 23.0821 12.3515C23.0821 12.3515 23.7565 6.60141 24.0862 5.64336Z",
    fill: "#908188"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.52964 0.248291C1.52964 0.248291 0.343927 1.54229 8.60922 10.6148C13.5267 16.0126 14.2347 15.7971 15.2874 15.2457C16.3412 14.6942 23.083 12.3516 23.083 12.3516C23.083 12.3516 23.0842 12.3452 23.0842 12.3371L1.55972 0.267307C1.54352 0.267307 1.52964 0.248291 1.52964 0.248291Z",
    fill: "#281D28"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0844 12.3379C23.1191 12.0445 23.7646 6.57599 24.0862 5.6433C24.2239 5.24396 24.2875 4.956 23.7403 4.59741L15.209 7.93157L23.0844 12.3379Z",
    fill: "#908188"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.2104 7.93066L13.9102 15.3252C14.5198 15.6159 14.8483 15.4755 15.2867 15.2464C16.3406 14.695 23.0824 12.3524 23.0824 12.3524C23.0824 12.3524 23.0835 12.346 23.0835 12.3379L15.2104 7.93066Z",
    fill: "#281D28"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.32 6.7011C19.4796 6.23656 19.4403 6.08171 15.5685 5.02043C11.6956 3.95915 8.39062 4.08683 8.39062 4.08683C8.39062 4.08683 9.29524 6.57794 11.8205 9.1098C14.3458 11.6417 14.5459 11.6208 15.0561 11.3537C15.5662 11.0866 18.833 9.95104 18.833 9.95104C18.833 9.95104 19.1604 7.16473 19.32 6.7011Z",
    fill: "#281D28"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7409 4.59755C23.7409 4.59755 19.5811 6.12246 19.3219 6.00293C19.0628 5.8834 16.5086 4.89456 14.0447 4.40286C11.5818 3.91115 8.39718 3.8532 8.39718 3.8532L1.5293 0.248291L8.23408 4.25978C8.23408 4.25978 8.58227 5.66154 10.3614 7.81398C12.1406 9.96643 14.3801 11.3935 14.3836 11.3917C14.3871 11.3899 10.6356 7.9154 9.62454 6.35155C8.6135 4.78771 8.63317 4.14388 8.63317 4.14388C8.63317 4.14388 11.9358 4.08502 15.2709 5.01409C18.6059 5.94316 19.1959 6.43215 19.1959 6.43215C19.1959 6.43215 18.5492 10.1349 18.8338 9.95284C19.1184 9.77083 19.7257 6.51274 19.7257 6.51274L23.7409 4.59755Z",
    fill: "#CFC2C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M23.2135 4.43271L19.4597 5.7421C19.4597 5.7421 17.0062 4.54499 13.9233 4.07231C10.8405 3.59962 8.5049 3.66572 8.5049 3.66572L2.46875 0.45291C2.46875 0.45291 10.8173 0.087076 23.2135 4.43271Z",
    fill: "#CFC2C4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.8 14.9513C15.8 14.9513 15.3604 13.2951 18.198 12.193C21.0356 11.0919 22.2306 12.5643 22.2306 12.5643L15.8 14.9513Z",
    fill: "#281D28"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.9689 12.5942C21.0771 12.6965 21.2669 12.7137 21.2669 12.7137L22.0222 12.3705C22.0222 12.3705 21.3201 11.5836 19.5305 11.8317C17.7386 12.0798 16.7658 12.8613 16.4338 13.2697C16.1018 13.6799 18.8619 12.4918 19.9689 12.5942Z",
    fill: "#281D28"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3755 10.6782C13.3755 10.6782 12.3355 11.1699 11.1718 10.0199C10.0081 8.86984 10.8109 8.05396 10.8109 8.05396L13.3755 10.6782Z",
    fill: "#CFC2C4"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.5239 10.5159C13.5239 10.5159 12.484 11.0076 11.3202 9.85763C10.1565 8.7076 10.9593 7.89172 10.9593 7.89172L13.5239 10.5159Z",
    fill: "#281D28"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.8797 3.03095C15.1948 3.06626 14.5251 3.03638 13.8599 2.99201C13.1947 2.94311 12.5354 2.86976 11.8806 2.7774C11.2259 2.68323 10.5769 2.56822 9.93374 2.42877C9.28941 2.28479 8.6497 2.12633 8.02734 1.90175C8.71217 1.86553 9.38195 1.89451 10.0471 1.93888C10.7134 1.98778 11.3716 2.06022 12.0264 2.1553C12.6811 2.24948 13.3301 2.36538 13.9744 2.50484C14.6164 2.64882 15.255 2.80728 15.8797 3.03095Z",
    fill: "#281D28"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16.143 3.01008C16.143 3.01008 13 3.06169 11.0554 2.64787C9.10968 2.23223 7.9043 1.81116 7.9043 1.81116C7.9043 1.81116 9.65221 2.62432 11.3365 2.97204C13.0208 3.31886 16.143 3.01008 16.143 3.01008Z",
    fill: "#CFC2C4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.0586 2.85797C14.0586 2.85797 11.4003 2.32914 10.9931 2.26213C10.5871 2.19512 9.02539 2.02307 9.02539 2.02307C9.02539 2.02307 11.693 2.98474 14.0586 2.85797Z",
    fill: "#281D28"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.96094 6.59227L8.09585 6.44648L9.31048 6.29797C9.31048 6.29797 8.78183 6.54609 8.30176 6.69731C7.82169 6.84763 5.72095 7.49961 5.72095 7.49961L4.96094 6.59227Z",
    fill: "#281D28"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23024 6.7344L9.25285 6.30518C9.25285 6.30518 7.96996 7.02235 7.87626 7.04952C7.78372 7.07578 5.97681 7.53851 5.85766 7.47331C5.73851 7.40902 8.23024 6.7344 8.23024 6.7344Z",
    fill: "#CFC2C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.03125 5.4115C4.03125 5.4115 7.24482 5.98289 7.53634 6.01096C7.82669 6.03903 9.2507 6.30616 9.2507 6.30616L8.09507 6.44742L4.96016 6.59322L4.03125 5.4115Z",
    fill: "#281D28"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.652 7.60022L20.6767 6.53984C20.6767 6.53984 16.1537 6.51177 15.9188 6.49638C15.6852 6.48008 11.5728 5.4677 11.2477 5.33277C10.9238 5.19785 10.2216 6.17039 9.97869 6.22925C9.73692 6.2872 11.2893 8.03125 11.2893 8.03125C11.2893 8.03125 14.3734 7.47344 14.4647 7.36025C14.5561 7.24797 17.9617 7.22895 17.9617 7.22895L23.593 8.3998L23.652 7.60022Z",
    fill: "#281D28"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7606 8.30654C21.7606 8.30654 19.5939 7.87551 19.4609 7.82842C19.3256 7.78133 17.4192 7.60113 17.4192 7.60113L12.0586 7.88818C12.0586 7.88818 14.1582 7.4164 14.4659 7.36026C14.7736 7.30412 17.8136 7.19727 17.8136 7.19727L23.5941 8.39981L21.7606 8.30654Z",
    fill: "#CFC2C4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.5989 8.29113L19.7444 6.99351L17.2423 6.80878L11.2119 6.5824L10.4785 7.0741C10.7897 7.46348 11.1414 7.86644 11.2524 7.9914C11.2744 8.00227 11.2964 8.01223 11.3218 8.0249C11.6608 7.96333 14.3769 7.4671 14.4625 7.36025C14.5539 7.24796 17.9595 7.22894 17.9595 7.22894L23.5908 8.39979L23.5989 8.29113Z",
    fill: "#281D28"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5903 124.653L18.7017 104.721L2.12832 106.214L2.07395 106.237C4.79126 105.098 13.0913 100.631 15.5043 95.2164C16.1406 93.7884 16.7849 91.4757 15.0439 87.8835C13.8443 85.4096 12.492 82.8677 11.0588 80.1756C6.49175 71.5957 1.76972 62.7233 0.389662 53.1927C-1.408 40.7733 3.02021 29.9994 13.5517 21.1705C25.4585 11.1879 27.5003 11.1616 27.7166 11.0919L46.3456 21.8894C46.3456 21.8894 38.845 27.0555 28.5414 35.6933C18.7943 43.8657 21.9812 52.6231 31.5803 70.6576C33.0298 73.3805 34.5278 76.1958 35.8766 78.9794C39.5876 86.6356 39.7681 94.6197 36.3972 102.07C29.8914 116.45 12.5464 123.856 10.5903 124.653Z",
    fill: "url(#paint7_linear_1122_2364)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1122_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 7,
    width: 26,
    height: 26
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 17.4659L32.2573 32.6616C36.6727 29.1554 40.5087 26.4424 43.1913 24.635L31.8547 7.50513C28.7499 9.54166 23.8566 12.9138 18.1016 17.4659Z",
    fill: "url(#paint8_linear_1122_2364)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1122_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 17.466L32.2572 32.6617C36.6727 29.1555 37.4836 28.2527 40.1662 26.4452L21.3128 15.338C18.208 17.3737 23.8566 12.9139 18.1016 17.466Z",
    fill: "url(#paint9_linear_1122_2364)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M8.18398 26.4452C1.55671 34.1793 -1.06458 43.1477 0.389507 53.1927C1.19579 58.7608 3.14383 64.1052 5.53377 69.2966L27.964 63.6461C22.1951 51.9241 20.5466 44.7441 25.7753 38.4353C20.2482 34.6393 13.0668 29.7241 8.18398 26.4452Z",
    fill: "url(#paint10_linear_1122_2364)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1122_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 75,
    width: 25,
    height: 35
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.314 86.1954H38.3036C37.8328 83.775 37.0242 81.3599 35.8697 78.9775C35.2901 77.7804 34.6793 76.5778 34.0593 75.3789L14.1289 86.0569C14.4389 86.6699 14.7408 87.2785 15.0347 87.8824C15.214 88.2519 15.362 88.6051 15.4939 88.9483L15.502 88.951C16.6461 91.9401 16.0746 93.9359 15.5032 95.2163C15.2788 95.7189 15.0034 96.2142 14.6876 96.6987L31.379 109.892C33.3467 107.564 35.0912 104.958 36.3983 102.07C38.7189 96.9377 39.3551 91.5526 38.314 86.1954Z",
    fill: "url(#paint11_linear_1122_2364)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1122_2364)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1122_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 59,
    width: 32,
    height: 24
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M31.6469 70.6668C29.4294 66.4996 27.5542 62.8285 26.1013 59.5442L2.37891 61.2267C4.52476 67.7836 7.86326 74.0589 11.1231 80.1848C11.5245 80.9391 11.9178 81.6789 12.3054 82.4124L33.3613 73.9095C32.7899 72.8202 32.2149 71.7353 31.6469 70.6668Z",
    fill: "url(#paint12_linear_1122_2364)"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1122_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M31.645 70.6667C29.4274 66.4994 27.5523 62.8284 26.0993 59.5441L2.37695 61.2265C4.52281 67.7835 7.86131 74.0588 11.1212 80.1847C11.5226 80.939 11.9159 81.6788 12.3034 82.4123L33.3594 73.9094C32.7879 72.82 32.213 71.7352 31.645 70.6667Z",
    fill: "url(#paint13_linear_1122_2364)"
  }))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9562 22.1285L40.3828 26.2487L42.5946 27.492L46.3461 22.2933L45.9562 22.1285Z",
    fill: "#8B899C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 25,
    width: 72,
    height: 128,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1122_2364",
    transform: "translate(0 -0.00435697) scale(0.00480769 0.00270433)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_2364",
    x1: 151.032,
    y1: 11.0919,
    x2: 151.032,
    y2: 124.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1122_2364",
    x1: 143.559,
    y1: 7.50513,
    x2: 143.559,
    y2: 32.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1122_2364",
    x1: 145.071,
    y1: 15.3289,
    x2: 145.071,
    y2: 32.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1122_2364",
    x1: 160.223,
    y1: 26.4452,
    x2: 160.223,
    y2: 69.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1122_2364",
    x1: 147.741,
    y1: 75.3789,
    x2: 147.741,
    y2: 109.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1122_2364",
    x1: 156.335,
    y1: 59.5442,
    x2: 156.335,
    y2: 82.4124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1122_2364",
    x1: 156.337,
    y1: 59.5441,
    x2: 156.337,
    y2: 82.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1122_2364",
    x1: 23.1728,
    y1: 11.0919,
    x2: 23.1728,
    y2: 124.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1122_2364",
    x1: 30.6464,
    y1: 7.50513,
    x2: 30.6464,
    y2: 32.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1122_2364",
    x1: 29.1339,
    y1: 15.3289,
    x2: 29.1339,
    y2: 32.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1122_2364",
    x1: 13.982,
    y1: 26.4452,
    x2: 13.982,
    y2: 69.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1122_2364",
    x1: 26.4637,
    y1: 75.3789,
    x2: 26.4637,
    y2: 109.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1122_2364",
    x1: 17.8701,
    y1: 59.5442,
    x2: 17.8701,
    y2: 82.4124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1122_2364",
    x1: 17.8682,
    y1: 59.5441,
    x2: 17.8682,
    y2: 82.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1122_2364",
    width: 208,
    height: 373,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbandonBg);
export default __webpack_public_path__ + "static/media/abandon_bg.ad4d78785482f9b87b40c3996681ce40.svg";
export { ForwardRef as ReactComponent };